import React, { useEffect, useState } from "react"
import { Modal, Paper } from "@mui/material"

import AssignCallsignLayout from "../layouts/AssignCallsignLayout"

import { Mission } from "../../../classes/Mission"

export default function AssignCallsignModal(props: {
    missionData: Mission,
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function
}) {

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <AssignCallsignLayout
                    title="Assign Callsign"
                    initInfo={props.missionData}
                    onSubmit={props.onSubmit}
                    onCancel={() => props.onClose()}
                />
            </Paper>
        </Modal>
    )
}